/**
 * Extrae el identificador ORCID (p. ej. 0000-0002-6894-9066) desde texto o URL.
 */
export function getOrcidId(raw) {
  if (raw == null || typeof raw !== 'string') return null;
  let s = raw.trim();
  if (!s) return null;
  s = s.replace(/^https?:\/\/(www\.)?orcid\.org\//i, '').replace(/\/+$/, '');
  return s || null;
}

/**
 * Devuelve la URL del perfil ORCID (https://orcid.org/�) si hay un identificador usable.
 */
export function getOrcidProfileUrl(raw) {
  const id = getOrcidId(raw);
  return id ? `https://orcid.org/${id}` : null;
}
